import React from "react";
import ComingSoon from "../Proximamente/Proximamente";

const ComingSoonPage = () => {
  return (
    <main className="coming-soon-wrapper">
      <ComingSoon />
    </main>
  );
};

export default ComingSoonPage;